
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { PrimeReactProvider } from 'primereact/api';
import Dashboard from './pages/Dashboard';
import Attendance from './components/attendance/Attendance';
import Exams from './pages/Exams';
import Reports from './pages/Reports';
import Settings from './pages/Settings';
import SystemStatus from './pages/SystemStatus';
import Analysis from './pages/Analysis';
import NotFound from './pages/NotFound';
import './App.css';

import { AuthProvider } from './contexts/AuthContext';
import Layout from './components/layout/Layout';
import Login from './components/auth/Login';
import Register from './components/auth/Register';
import ProtectedRoute from './components/common/ProtectedRoute';
import Students from './components/students/Students';
import Employees from './components/employees/Employees';
import Admissions from './components/admissions/Admissions';
import Lectures from './components/lectures/Lectures';
import LectureView from './components/lectures/LectureView';
import Classes from './components/classes/Classes';
import CouponGenerator from './components/coupons/CouponGenerator';
import FeeStructures from './components/fees/Fees';
import ParentsInfo from './components/parents/ParentsInfo';

function App() {
  return (
    <PrimeReactProvider value={{ hideOverlaysOnDocumentScrolling: true }}>
      <AuthProvider>
        <Router>
          <div className="App">
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />

              {/* Protected routes */}
              <Route path="/dashboard" element={
                <ProtectedRoute>
                  <Layout><Dashboard /></Layout>
                </ProtectedRoute>
              } />

              {/* Classes routes */}
              <Route path="/classes" element={
                <ProtectedRoute allowedRoles={['admin', 'management', 'teacher']}>
                  <Layout><Classes /></Layout>
                </ProtectedRoute>
              } />

              {/* Students routes */}
              <Route path="/students" element={
                <ProtectedRoute allowedRoles={['admin', 'management', 'teacher', 'accountant']}>
                  <Layout><Students /></Layout>
                </ProtectedRoute>
              } />

              {/* Parents routes */}
              <Route path="/parents" element={
                <ProtectedRoute allowedRoles={['admin', 'management', 'teacher', 'accountant']}>
                  <Layout><ParentsInfo/></Layout>
                </ProtectedRoute>
              } />

              {/* Employees routes */}
              <Route path="/employees" element={
                <ProtectedRoute allowedRoles={['admin', 'management','teacher']}>
                  <Layout> <Employees /> </Layout>
                </ProtectedRoute>
              } />

              {/* Admissions routes */}
              <Route path="/admissions" element={
                <ProtectedRoute allowedRoles={['admin', 'management','teacher']}>
                  <Layout><Admissions /></Layout>
                </ProtectedRoute>
              } />

              {/* Fees routes */}
              <Route path="/fees" element={
                <ProtectedRoute allowedRoles={['admin', 'management', 'teacher']}>
                  <Layout><FeeStructures /></Layout>
                </ProtectedRoute>
              } />

              <Route path="/coupons" element={
                <ProtectedRoute allowedRoles={['admin', 'management', 'teacher', 'accountant']}>
                  <Layout><CouponGenerator /></Layout>
                </ProtectedRoute>
              } />

              <Route path="/lectures" element={
                <ProtectedRoute allowedRoles={['admin', 'management', 'teacher', 'accountant']}>
                  <Layout><Lectures /></Layout>
                </ProtectedRoute>
              } />

              <Route path="/lectures/:id" element={
                <ProtectedRoute allowedRoles={['admin', 'management', 'teacher', 'accountant']}>
                  <Layout><LectureView /></Layout>
                </ProtectedRoute>
              } />

              {/* Attendance routes */}
              <Route path="/attendance" element={
                <ProtectedRoute allowedRoles={['admin', 'management', 'teacher']}>
                  <Layout><Attendance /></Layout>
                </ProtectedRoute>
              } />

              {/* Exams routes */}
              <Route path="/exams" element={
                <ProtectedRoute allowedRoles={['admin', 'management', 'teacher']}>
                  <Layout><Exams /></Layout>
                </ProtectedRoute>
              } />

              {/* Reports routes */}
              <Route path="/reports"
                element={
                  <ProtectedRoute allowedRoles={['admin', 'management', 'accountant']}>
                    <Layout><Reports /></Layout>
                  </ProtectedRoute>
                } />


              {/* Settings routes */}
              <Route path="/settings" element={
                <ProtectedRoute allowedRoles={['admin']}>
                  <Layout><Settings /></Layout>
                </ProtectedRoute>
              } />

              {/* System Status route */}
              <Route path="/status" element={
                <ProtectedRoute allowedRoles={['admin', 'management']}>
                  <Layout><SystemStatus /> </Layout>
                </ProtectedRoute>
              }
              />

              {/* Analysis route */}
              <Route path="/analysis" element={
                <ProtectedRoute allowedRoles={['admin', 'management', 'teacher']}>
                  <Layout><Analysis /></Layout>
                </ProtectedRoute>
              } />

              {/* Student-specific routes */}
              <Route path="/my-attendance" element={
                <ProtectedRoute allowedRoles={['student']}>
                  <Layout>
                    <div className="text-center py-12">
                      <h1 className="text-2xl font-bold text-gray-900">My Attendance</h1>
                      <p className="text-gray-600 mt-2">Coming soon...</p>
                    </div>
                  </Layout>
                </ProtectedRoute>
              }
              />

              <Route path="/my-exams" element={
                <ProtectedRoute allowedRoles={['student']}>
                  <Layout>
                    <div className="text-center py-12">
                      <h1 className="text-2xl font-bold text-gray-900">My Exams</h1>
                      <p className="text-gray-600 mt-2">Coming soon...</p>
                    </div>
                  </Layout>
                </ProtectedRoute>
              }
              />
              {/* Default redirect */}
              <Route path="/" element={<Navigate to="/dashboard" replace />} />

              {/* 404 page */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </div>
        </Router>
      </AuthProvider>
    </PrimeReactProvider>
  );
}

export default App;
